import { View, Text } from "react-native";
import React from "react";
import TestSectionIcon from "../../assets/svg/TestSectionIcon";
import MyText from "../custom/MyText";
import BabyIcon from "../../assets/svg/BabyIcon";
import translate from "../../functions/translate";
import TestCalendarIcon from "../../assets/svg/TestCalendarIcon";
import MyButton from "../custom/MyButton";
import CircleChart from "../../assets/svg/CircleChart";
import ProgressBar from "../custom/ProgressBar";
import ResultIcon from "../../assets/svg/ResultIcon";
import GalleryIcon from "../../assets/svg/GalleryIcon";
import TestPart from "./TestPart";
import { useEffect } from "react";
import getASQ3TestDetails from "../../api/test/getASQ3TestDetails";
import { useState } from "react";
import getASQSE2TestDetails from "../../api/test/getASQSE2TestDetials";
import { useIsFocused, useNavigation } from "@react-navigation/native";
import getADHDTestDetails from "../../api/test/getADHDTestDetials";
import { useSelector } from "react-redux";
import { Video } from "expo-av";
import moment from "jalali-moment";
import childrenList from "../../api/get/childrenList";
import MyVideo from "../MyVideo";
import AnswerReviewItem from "./AnswerReviewItem";
import Fade from "../animation/Fade";

const Participated = ({ details, childId }) => {
  const [responseShow, setResponseShow] = useState(false);
  const main = useSelector((store) => store.main);
  const navigation = useNavigation();
  const descriptionText = main.rtl
    ? details.answered.descreptionsFa
    : details.answered.descreptionsEn;
  const videoUrl = main.rtl ? details.answered.urlFa : details.answered.urlEn;
  const score = details.score || null;

  const [childChatDetail, setChildChatDetail] = useState({});
  const [childDetail, setChildDetail] = useState({});

  useEffect(() => {
    childrenList()
      .then(({ data }) => {
        if (data.status === 200) {

          const children = data.data.filter((item) => item.id === childId);


          if (children.length > 0) {
            setChildDetail(children[0]);
            const chats = children[0].listCounseling;
            if (chats.length > 0) {
              setChildChatDetail(chats[0]);
            }
          }
        }
      })
      .catch((err) => {});
  }, []);


  return (
    <View style={{ width: "100%", alignItems: "center" }}>
      <View style={{ flexDirection: "row", width: "100%" }}>
        <TestSectionIcon />
        <MyText
          style={{ marginHorizontal: 10, fontSize: 20, color: "#48A9C2" }}
        >
          آزمون
        </MyText>
      </View>
      <View
        style={{
          marginTop: 10,
          width: "95%",
          backgroundColor: "#F9F9F9",
          alignItems: "center",
          flexDirection: "row",
          padding: 10,
          borderRadius: 15,
          borderWidth: 1,
          borderColor: "#dcdcdc",
          minHeight: 30,
        }}
      >
        <View
          style={{
            width: 35,
            height: 35,
            borderRadius: 20,
            backgroundColor: "#FF9356",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <View style={{ transform: [{ scale: 1.4 }] }}>
            <BabyIcon color="white" />
          </View>
        </View>
        <MyText style={{ marginHorizontal: 7 }}>{translate("test age")}</MyText>
        <View style={{ flex: 1 }}></View>
        <MyText>{`${
          details.detail !== undefined ? details.detail.Age : ""
        } ${translate("monthy")}`}</MyText>
      </View>
      <View
        style={{
          marginTop: 10,
          width: "95%",
          backgroundColor: "#F9F9F9",
          alignItems: "center",
          flexDirection: "row",
          padding: 10,
          borderRadius: 15,
          borderWidth: 1,
          borderColor: "#dcdcdc",
          minHeight: 30,
        }}
      >
        <View
          style={{
            width: 35,
            height: 35,
            borderRadius: 20,
            backgroundColor: "#57ACDC",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <View style={{ transform: [{ scale: 1.2 }] }}>
            <TestCalendarIcon color="white" />
          </View>
        </View>
        <MyText style={{ marginHorizontal: 7 }}>
          {translate("test participated date")}
        </MyText>
        <View style={{ flex: 1 }}></View>
        <MyText style={{ fontSize: 13 }}>
          {`${
            main.rtl
              ? details.detail.dateEndFa.split("-").join("/")
              : details.detail.dateEnd
          }`}
        </MyText>
      </View>
      <View
        style={{
          width: "94%",
          flexDirection: "row",
          alignItems: "center",
          marginTop: 10,
        }}
      >
        <CircleChart />
        <MyText style={{ marginHorizontal: 5, fontSize: 13, marginTop: 3 }}>
          {translate("answered questions")}
        </MyText>
        <View style={{ flex: 1, marginHorizontal: 5 }}>
          <View style={{ flexDirection: "row" }}>
            <MyText style={{ marginHorizontal: 1, fontSize: 12 }}>{`${
              details.answered !== undefined
                ? details.answered.countAnswered
                : ""
            }`}</MyText>
            <MyText style={{ marginHorizontal: 1, fontSize: 12 }}>
              {translate("from")}
            </MyText>
            <MyText style={{ marginHorizontal: 1, fontSize: 12 }}>{`${
              details.answered !== undefined
                ? details.answered.countQuestion
                : ""
            }`}</MyText>
            <MyText style={{ marginHorizontal: 1, fontSize: 12 }}>
              {translate("question")}
            </MyText>
          </View>
          <View
            style={{
              width: "100%",
              padding: 1,
              backgroundColor: "#eee",
              borderRadius: 30,
            }}
          >
            <ProgressBar
              color="#FF9356"
              progress={
                (details.answered.countQuestion /
                  details.answered.countAnswered) *
                100
              }
            />
          </View>
        </View>
      </View>
      <MyButton
        style={{ marginTop: 20, marginBottom: 10 }}
        text={responseShow ? translate("close") : translate("show answers")}
        onPress={() => setResponseShow(!responseShow)}
      />
      <Fade isShown={responseShow} style={{ width: "100%" }}>
        {details.question.map((question, index) => (
          <AnswerReviewItem
            key={index}
            number={index + 1}
            text={main.rtl ? question.titleFa : question.titleEn}
            answer={details.response.find((d) => d.id === question.id)}
          />
        ))}
      </Fade>
      {score !== null && (
        <View style={{ width: "94%", marginTop: 10 }}>
          <View style={{ flexDirection: "row", alignItems: "center" }}>
            <CircleChart />
            <MyText
              style={{
                marginHorizontal: 3,
                color: "#57ACDC",
                marginTop: 3,
                fontWeight: "bold",
                fontSize: 16,
              }}
            >
              {translate("score")}
            </MyText>
          </View>
          <View style={{ width: "100%", marginTop: 10 }}>
            <MyText style={{ fontSize: 16 }}>{`${score}`}</MyText>
          </View>
        </View>
      )}
      {(descriptionText !== null || descriptionText !== "") && (
        <View style={{ width: "94%", marginTop: 10 }}>
          <View style={{ flexDirection: "row", alignItems: "center" }}>
            <ResultIcon />
            <MyText
              style={{
                marginHorizontal: 3,
                color: "#57ACDC",
                marginTop: 3,
                fontWeight: "bold",
                fontSize: 16,
              }}
            >
              {translate("test result")}
            </MyText>
          </View>
          <View style={{ width: "100%", marginTop: 10 }}>
            <MyText style={{ fontSize: 13 }}>{`${descriptionText}`}</MyText>
          </View>
        </View>
      )}
      {videoUrl !== null && videoUrl !== "" && (
        <View style={{ width: "94%", marginTop: 10 }}>
          <View style={{ flexDirection: "row", alignItems: "center" }}>
            <GalleryIcon color="#57ACDC" />
            <MyText
              style={{
                marginHorizontal: 3,
                color: "#57ACDC",
                marginTop: 3,
                fontWeight: "bold",
                fontSize: 16,
              }}
            >
              {translate("description video")}
            </MyText>
          </View>
          <View style={{ width: "100%", marginTop: 10, alignItems: "center" }}>
            <MyVideo url={videoUrl} />
          </View>
        </View>
      )}
    </View>
  );
};

const NotParticipated = ({ details, type, testId, childId }) => {
  const navigation = useNavigation();

  return (
    <View style={{ width: "100%", alignItems: "center", marginTop: 10 }}>
      <View style={{ flexDirection: "row", width: "100%" }}>
        <TestSectionIcon />
        <MyText
          style={{ marginHorizontal: 10, fontSize: 20, color: "#48A9C2" }}
        >
          آزمون
        </MyText>
      </View>
      <View
        style={{
          marginTop: 10,
          width: "95%",
          backgroundColor: "#F9F9F9",
          alignItems: "center",
          flexDirection: "row",
          padding: 10,
          borderRadius: 15,
          borderWidth: 1,
          borderColor: "#dcdcdc",
          minHeight: 30,
        }}
      >
        <View
          style={{
            width: 35,
            height: 35,
            borderRadius: 20,
            backgroundColor: "#FF9356",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <View style={{ transform: [{ scale: 1.4 }] }}>
            <BabyIcon color="white" />
          </View>
        </View>
        <MyText style={{ marginHorizontal: 7 }}>{translate("test age")}</MyText>
        <View style={{ flex: 1 }}></View>
        <MyText>{`${
          details.detail !== undefined ? details.detail.Age : ""
        } ${translate("monthy")}`}</MyText>
      </View>
      <View
        style={{
          marginTop: 10,
          width: "95%",
          backgroundColor: "#F9F9F9",
          alignItems: "center",
          flexDirection: "row",
          padding: 10,
          borderRadius: 15,
          borderWidth: 1,
          borderColor: "#dcdcdc",
          minHeight: 30,
        }}
      >
        <View
          style={{
            width: 35,
            height: 35,
            borderRadius: 20,
            backgroundColor: "#57ACDC",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <View style={{ transform: [{ scale: 1.2 }] }}>
            <TestCalendarIcon color="white" />
          </View>
        </View>
        <MyText style={{ marginHorizontal: 7 }}>
          {translate("test participated date")}
        </MyText>
        <View style={{ flex: 1 }}></View>
        <MyText style={{ fontSize: 13 }}>
          {translate("not participated")}
        </MyText>
      </View>
      <View
        style={{
          width: "96%",
          flexDirection: "row",
          marginTop: 20,
          marginBottom: 10,
        }}
      >
        <View style={{ flex: 1 }}></View>
      </View>
    </View>
  );
};

const MultiPart = ({ details, testId, childId }) => {
  const main = useSelector((store) => store.main);

  return (
    <View>
      <View style={{ flexDirection: "row", width: "100%" }}>
        <TestSectionIcon />
        <MyText
          style={{ marginHorizontal: 10, fontSize: 20, color: "#48A9C2" }}
        >
          آزمون
        </MyText>
      </View>
      <View
        style={{
          marginTop: 10,
          width: "100%",
          backgroundColor: "#F9F9F9",
          alignItems: "center",
          flexDirection: "row",
          padding: 10,
          borderRadius: 15,
          borderWidth: 1,
          borderColor: "#dcdcdc",
          minHeight: 30,
        }}
      >
        <View
          style={{
            width: 35,
            height: 35,
            borderRadius: 20,
            backgroundColor: "#FF9356",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <View style={{ transform: [{ scale: 1.4 }] }}>
            <BabyIcon color="white" />
          </View>
        </View>
        <MyText style={{ marginHorizontal: 7 }}>{translate("test age")}</MyText>
        <View style={{ flex: 1 }}></View>
        <MyText>{`${
          details.detail !== undefined ? details.detail.Age : ""
        } ${translate("monthy")}`}</MyText>
      </View>
      <View
        style={{
          marginVertical: 10,

          width: "100%",
          backgroundColor: "#F9F9F9",
          alignItems: "center",
          flexDirection: "row",
          padding: 10,
          borderRadius: 15,
          borderWidth: 1,
          borderColor: "#dcdcdc",
          minHeight: 30,
        }}
      >
        <View
          style={{
            width: 35,
            height: 35,
            borderRadius: 20,
            backgroundColor: "#57ACDC",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <View style={{ transform: [{ scale: 1.2 }] }}>
            <TestCalendarIcon color="white" />
          </View>
        </View>
        <MyText style={{ marginHorizontal: 7 }}>
          {translate("test participated date")}
        </MyText>
        <View style={{ flex: 1 }}></View>
        <MyText style={{ fontSize: 13 }}>
          {details.answered !== undefined &&
          Object.keys(details.answered).length === 6
            ? `${
                main.rtl
                  ? details.detail.dateEndFa.split("-").join("/")
                  : details.detail.dateEnd
              }`
            : translate("not completed")}
        </MyText>
      </View>
      {details.answered !== undefined &&
        Object.keys(details.answered).map((item, index) =>
          !["General", "dataEnd", "dataEndFa"].includes(item) ? (
            <TestPart
              answer={details.answered[item]}
              participated={true}
              key={index}
              index={index}
              part={item}
              questionCount={details.question[item].length}
              details={details}
              childId={childId}
              testId={testId}
              score={details.score[item]}
            />
          ) : null
        )}
      {details.question !== undefined &&
        Object.keys(details.question).map((item, index) =>
          details.answered === undefined ||
          !Object.keys(details.answered).includes(item) ? (
            <TestPart
              key={index}
              index={index}
              part={item}
              questionCount={details.question[item].length}
              participated={false}
              details={{ details, question: details.question[item] }}
              childId={childId}
              testId={testId}
            />
          ) : null
        )}
    </View>
  );
};

export default function TestSectionDetails({ id, type, childId, changed }) {
  const [testDetails, setTestDetails] = useState({});

  const isFocused = useIsFocused();
  useEffect(() => {
    if (isFocused) {
      if (type === "ASQ3") {
        getASQ3TestDetails(childId, id)
          .then(({ data }) => {
          
            if (data.status === 200) {
              setTestDetails(data.data);
            }
          })
          .catch((err) => {});
      } else if (type === "ASQSE2") {
        getASQSE2TestDetails(childId, id)
          .then(({ data }) => {
            if (data.status === 200) {
              setTestDetails(data.data);
            }
          })
          .catch((err) => {});
      } else if (type === "ADHD") {
        getADHDTestDetails(childId, id)
          .then(({ data }) => {
            if (data.status === 200) {
              setTestDetails(data.data);
            }
          })
          .catch((err) => {});
      }
    }
  }, [id, type, changed, isFocused]);
  return (
    <View
      style={{
        width: "94%",
        borderWidth: 1,
        borderColor: "#bbb",
        borderRadius: 15,
        padding: 10,
        marginTop: 10,
      }}
    >
      {/* <Participated /> */}
      {type !== "ASQ3" && testDetails.answered === undefined && (
        <NotParticipated
          details={testDetails}
          type={type}
          childId={childId}
          testId={id}
        />
      )}
      {type !== "ASQ3" && testDetails.answered !== undefined && (
        <Participated details={testDetails} childId={childId} />
      )}
      {type === "ASQ3" && (
        <MultiPart
          details={testDetails}
          type={type}
          childId={childId}
          testId={id}
        />
      )}
    </View>
  );
}
